/* Cart Empty, Show Menu */

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['doradoFashion2214'] = function(){
  if(typeof $ == 'function' && $('#CartDrawer .drawer__inner #CartContainer').length && !document.getElementsByClassName('doradoFashion2214').length){
    document.body.classList.add('doradoFashion2214');
    function afterAjaxStopFn() {
      if($('#CartDrawer .drawer__inner #CartContainer p:contains(Your cart is currently empty.)').length){
        if(!$('#CartDrawer .startShoppingMiniCart').length){
          var html = '<div class="startShoppingMiniCart appear-animation appear-delay-3">';
          html += '<h3>Start Shopping</h3>';
          html += '<div class="startShoppingLinksWrap clearfix"><div class="linkOuterCols"><a href="/collections/custom-accessories" class="btn">Shop All</a></div><div class="linkOuterCols"><a href="/collections/necklaces" class="btn">Necklaces</a></div><div class="linkOuterCols"><a href="/collections/bracelets-1" class="btn">Bracelets </a></div><div class="linkOuterCols"><a href="/collections/rings" class="btn">Rings</a></div><div class="linkOuterCols"><a href="/collections/earrings" class="btn">Earrings</a></div><div class="linkOuterCols"><a href="/collections/anklets" class="btn">Anklets</a></div><div class="linkOuterCols"><a href="/collections/custom-accessories/Iced-Out" class="btn">Iced Out</a></div></div>';
          html += '</div>';
          $('#CartDrawer .drawer__inner #CartContainer').append(html);
        }
      }else{
        $('#CartDrawer .startShoppingMiniCart').remove();
      }
    };
    //afterAjaxStopFn();
    $(document).ajaxComplete(function(){
     // afterAjaxStopFn();
      console.log('Ajax Completed...');
    });
    console.log('Main Function Running. (2214)');
  }else if(!document.getElementsByClassName('doradoFashion2214').length){
    window.requestAnimationFrame(doradoFashion2214);
  }
};
window.doradoFashion2214();

/* 

$(document).ready(function(){
  var showUsp = requestAnimationFrame(function tryChanges(){
    if(typeof $ == 'function' && !$('body.running1705var2').length){
      updatePDP();
      window.onresize = function(){
        updatePDP();
      };
      $('body').addClass('running1705var2');
      requestAnimationFrame(tryChanges);
    }
  });
  function updatePDP(){
    console.log('VWO - update PDP');
    if(window.matchMedia('(max-width:767px)').matches){
      if($('button.add-to-cart.bold_clone[id^="AddToCart-"]').length && !$('.uspSection').length){
        $('button.add-to-cart.bold_clone[id^="AddToCart-"]').after('<div class="uspSection">Free Shipping + Gift Box Included</div>');
      }
      if($('input[name="properties[CUSTOM TEXT]"]').length){
        $('input[name="properties[CUSTOM TEXT]"]').attr('placeholder', 'Type your custom text here :)');
        if($('input[name="properties[CUSTOM TEXT]"]').attr('placeholder') == $('input[name="properties[CUSTOM TEXT]"]').parents('label').next('span.bold_help_text').find('small').text()){
            $('input[name="properties[CUSTOM TEXT]"]').parents('label').next('span.bold_help_text').hide();
        }
      }
      if($('span[id^="SavePrice-"]').length){
        var discountText = ($('span[id^="SavePrice-"]').text().trim()).split('You Save').pop().split(" ")[1] + ' OFF';
        if($('.product__main-photos').length && !$('.discountPriceTag').length){
          $('.product__main-photos').prepend('<div class="discountPriceTag"><span>'+ discountText +'</span></div>');
          resetSlickMobile();
          if(!$('.slick-initialized').length){
            setTimeout(function(){
              resetSlickMobile();
            },200);
            }
        }
      }
    }
    else{
      rollBackChanges();
    }
  }
  function rollBackChanges(){
    console.log('VWO - roll back changes');
    $('.uspSection').remove();
    if($('input[name="properties[CUSTOM TEXT]"]').length){
      $('input[name="properties[CUSTOM TEXT]"]').attr('placeholder', '');
      
    }
    if($('.product__main-photos').length){
      $('.discountPriceTag').remove();
      resetSlickDesktop();
    }
  }
  function resetSlickMobile(){
    console.log('VWO - resetSlickMobile');
    $('div[id ^= ProductPhotos-]').slick('unslick');
    $('div[id ^= ProductPhotos-]').slick({
      arrows:false,
      asNavFor:'.product__thumbs',
      slidesToShow:1,
      adaptiveHeight:true,
      fade:false,
      dots:false,
      focusOnSelect: true,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0'
    });
    $('div[id ^= ProductThumbs-]').slick('unslick');
    $('div[id ^= ProductThumbs-]').slick({
      arrows:true,
      asNavFor:'.product__main-photos > .slick-slider',
      slidesToShow:3,
      slidesToScroll: 1,
      focusOnSelect:true
    });
  } 
  function resetSlickDesktop(){
    console.log('VWO - resetSlickDesktop');
    $('div[id ^= ProductPhotos-]').slick({
        arrows:false,
        asNavFor:'.product__thumbs',
        slidesToShow:1,
        adaptiveHeight:true,
        fade:false,
        dots:false,
        slidesToScroll: 1
      });
      $('div[id ^= ProductThumbs-]').slick('unslick');
      $('div[id ^= ProductThumbs-]').slick({
        arrows:false,
        asNavFor:'.product__main-photos > .slick-slider',
        slidesToShow:5,
        slidesToScroll: 1,
        focusOnSelect:true
      });
  }

  var plpChanges = requestAnimationFrame(function tryChanges(){
    if(typeof $ == 'function' && !$('body.running1710').length){
      updateChanges();
      $(document).ajaxComplete(function(){
        updateChanges();
      });
      $('body').addClass('running1710');
      $(window).scroll();
      requestAnimationFrame(tryChanges);
    }
  });
  */

   /* Collection Changes 
  
  
  
  function updateChanges(){
    if($('#PageContainer').length && !$('#PageContainer > .stickyFixed').length){
      $('#PageContainer').append('<div class="stickyFixed plug-stickyFixed"></div>');
    }
    if($('.collection-filter__item--drawer').length){
      $('.collection-filter__item--drawer').prependTo('.stickyFixed');
    }
    if(!$('.vwo_sortBySec').length){
      $('.stickyFixed').append('<div class="vwo_sortBySec"><button type="button" class="btn btn--tertiary"><img data-src="https://useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/cbd14ac98f254382a7217c205f6ece55_1267043.png" class="lazy"/>Sort</button></div>');
    }
    manageSticky();
    $(document).scroll(function(){
      manageSticky();
    });
    if($('#CollectionSidebar').length && !$('#sortDrawer').length){
      $('#CollectionSidebar').append('<div id="sortDrawer" class="drawer drawer--right"> <div class="drawer__fixed-header"> <div class="drawer__header appear-animation appear-delay-1"> <div class="h2 drawer__title">Sort By</div><div class="drawer__close"> <button type="button" class="drawer__close-button js-drawer-close"> <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"> <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path> </svg> <span class="icon__fallback-text">Close menu</span> </button> </div></div></div><div class="drawer__inner appear-animation appear-delay-2"> <div class="collection-sidebar__group--3223"> <div class="collection-sidebar__group"> <div class="collapsible-content collapsible-content--sidebar is-open" style="height:auto;"> <div class="collapsible-content__inner"> <ul class="no-bullets"><li> <a href="javascript:void(0);" data-sort="discount"> Discounts </a> </li><li> <a href="javascript:void(0);" data-sort="price-ltoh"> Price: Low to High </a> </li><li> <a href="javascript:void(0);" data-sort="price-htol"> Price: High to Low </a> </li></ul> </div></div></div></div></div></div>');
      $('.vwo_sortBySec > button').click(function(){
        $('#sortDrawer').addClass('is-transitioning');
        setTimeout(function(){
          $('html,body').addClass('js-drawer-open');
          $('#sortDrawer').addClass('drawer--is-open');
        },100);
        setTimeout(function(){
          $('#sortDrawer').removeClass('is-transitioning');
        },400);
      });
      $('#MainContent').click(function(e){
        if(!$(e.target).is('.drawer--is-open') && !$(e.target).is('.drawer--is-open *')){
          $('#sortDrawer').addClass('is-transitioning');
          setTimeout(function(){
            $('html,body').removeClass('js-drawer-open');
            $('#sortDrawer').removeClass('drawer--is-open');
          },100);
          setTimeout(function(){
            $('#sortDrawer').removeClass('drawer--is-open is-transitioning');
          },400);
        }
      });
      $('.drawer__close-button').click(function(){
        $('#MainContent').trigger('click');
      });
      $('a[data-sort]').click(function(){
        $(this).addClass('active');
        $('a[data-sort]').not($(this)).removeClass('active');
        sortData($(this).attr('data-sort'));
        $('#MainContent').trigger('click');
        $('html,body').animate({
          scrollTop:$('#CollectionSection').offset().top
        },400);
      });
      $('.grid--collection > .grid__item').addClass('aos-animate');
    }
    implementLazyLoading();
  }
  function manageSticky(){
    if($(document).scrollTop() > $('#CollectionSection').offset().top){
      $('.stickyFixed').addClass('opened');
      $('iframe#launcher').css('margin-bottom', '60px');
    }
    else{
      $('.stickyFixed').removeClass('opened');
      $('iframe#launcher').css('margin-bottom', '10px');
    }
  }
  function sortData(sortValue){
    switch(sortValue){
      case 'latest' :
        sortByLatest();
        break;
      case 'discount' :
        sortByDiscount();
        break;
      case 'price-ltoh' :
        sortByPriceLtoH();
        break;
      case 'price-htol':
        sortByPriceHtoL();
        break;
    }
  }
  function sortByLatest(){
  }
  function sortByDiscount(){
    var sortedElems = [];
    var unsortedElems = [];
    var gridItems = $('.grid--collection > .grid__item');
    $('.grid--collection').empty();
    gridItems.each(function(index, el){
      unsortedElems.push(el);
    });
    sortedElems = unsortedElems.sort(function(a,b){
      var discA = parseInt($(a).find('.grid-product__price > span.grid-product__price--savings').text().trim().split('e ').pop().split('%').shift());
      var discB = parseInt($(b).find('.grid-product__price > span.grid-product__price--savings').text().trim().split('e ').pop().split('%').shift());
      return discB - discA;
    });
    $('.collection-filter').next('.grid--collection').append(sortedElems);
  }
  function sortByPriceLtoH(){
    var sortedElems = [];
    var unsortedElems = [];
    var gridItems = $('.grid--collection > .grid__item');
    $('.collection-filter').next('.grid--collection').empty();
    gridItems.each(function(index, el){
      unsortedElems.push(el);
    });
    sortedElems = unsortedElems.sort(function(a,b){
      var priceA = parseFloat($(a).find('.grid-product__price > span.money').text().split('$').pop());
      var priceB = parseFloat($(b).find('.grid-product__price > span.money').text().split('$').pop());
      return priceA - priceB;
    });
    $('.collection-filter').next('.grid--collection').append(sortedElems);
  }
  function sortByPriceHtoL(){
    var sortedElems = [];
    var unsortedElems = [];
    var gridItems = $('.grid--collection > .grid__item');
    $('.grid--collection').empty();
    gridItems.each(function(index, el){
      unsortedElems.push(el);
    });
    sortedElems = unsortedElems.sort(function(a,b){
      var priceA = parseFloat($(a).find('.grid-product__price > span.money').text().split('$').pop());
      var priceB = parseFloat($(b).find('.grid-product__price > span.money').text().split('$').pop());
      return priceB - priceA;
    });
    $('.collection-filter').next('.grid--collection').append(sortedElems);
  }
  function implementLazyLoading(){
    $(window).scroll(function(){
      if($(this).scrollTop() >= ($('.collection-filter').next('.grid--collection')).outerHeight()){
        if(!$('.vwo_loading').length){
          if($('.pagination > span.current').next('span').length){
            $('#CollectionSection').append('<div class="vwo_loading"></div>');
            callProductsPage($('.pagination > span.current').next('span').find('a').attr('href'));
          }
        }
      }
    });
    
    
    
  }
  function callProductsPage(url){
    $.ajax({
      url:url,
      type:'get',
      success:function(data){
        var html = $(data);
        if(html.find('.collection-filter').next('.grid--collection').children('.grid__item').length){
          $('.collection-filter').next('.grid--collection').append(html.find('.collection-filter').next('.grid--collection').children('.grid__item').addClass('aos-animate'));
          $('.running1710 .pagination').html(html.find('.pagination').html());
          $('.vwo_loading').remove();
        }
      },
      error:function(err){
        $('.vwo_loading').remove();
      }
    });
  }
});
*/
	
  /*Product Variant Options 
  
  window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
  window['doradoFashionPDP1937V1'] = function(){
  if(typeof $ !== typeof undefined && $(".variant-wrapper .variant-input-wrap").length && !$('.doradoFashionPDP1937V1').length){
    $("body").addClass('doradoFashionPDP1937V1');
    $("head").prepend('<meta name="viewport" content="width=device-width, initial-scale=1">');
    updateMaterialOption();
  }else{
    window.requestAnimationFrame(doradoFashionPDP1937V1);
  }
};
  window.doradoFashionPDP1937V1();
function updateMaterialOption(){
  $(".variant-wrapper .variant-input-wrap").each(function(){
    var lbl = $(this).prev("label").text().toLowerCase().trim();
    if(lbl.indexOf('material') !== -1 || lbl.indexOf('metal') !== -1){
      $(this).prev("label").addClass("materialLabel");
      $(this).addClass("materialWrapper").find("select").addClass("materialDropdown");
      if(!$(".materialSwatched").length){
        $(this).find("select").after('<div class="materialSwatched"><ul class="swatches"></ul></div>');
      }
      var htm = '';
      $(this).find("select").find("option").each(function(){
        var val = $(this).attr("value"),
            txt = $(this).text().trim(),
            selected = "";
        var className = getClassName(txt);
        if(typeof $(this).attr("selected") !== typeof undefined){
          selected = "selected";
        }
        htm  += '<li class="' + selected + ' ' + className + '"><a href="javascript:void(0);" onclick="changeMaterialOption(\'' + val + '\', this)">' + txt + '</a></li>';
      });
      $(".materialSwatched .swatches").html(htm);
    }
  });
}
function getClassName(txt){
  txt = txt.toLowerCase();
  var className = '';
  if(txt.indexOf('rose gold plated') !== -1){
    className = 'rose_gold_plated';
  }
  else if(txt.indexOf('gold plated') !== -1){
    className = 'gold_plated';
  }
  else if(txt.indexOf('silver stainless steel') !== -1){
    className = 'silver_stainless_steel';
  }
  else if(txt.indexOf('solid yellow gold') !== -1){
    className = 'solid_yellow_gold';
  }
  else if(txt.indexOf('silver plated') !== -1){
    className = 'silver_plated';
  }
  else if(txt.indexOf('silver') !== -1){
    className = 'silver';
  }
  return className;
}
function changeMaterialOption(val, t){
  $(t).parent().siblings().removeClass("selected");
  $(t).parent().addClass("selected");
  $(".materialDropdown").val(val).change();
}

*/



/* Product Tiles Redesign 

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['DF_2368_V1'] = function(){
  if(document.querySelectorAll('.grid__item.grid-product').length && !document.querySelectorAll('.DF_2368_V1').length){
    document.querySelector('body').classList.add('DF_2368_V1');
  }else if(!document.getElementsByClassName('DF_2368_V1').length){
    window.requestAnimationFrame(DF_2368_V1);
  }
};
window.DF_2368_V1();

*/

/* Add save amount to checkout 

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['doradoFashionCheckout2321V1'] = function(){
  if(document.querySelectorAll('.order-summary__section__content').length && document.querySelectorAll(".order-summary__section--total-lines .total-line-table__tbody").length && !document.getElementsByClassName('doradoFashionCheckout2321V1').length){
    document.body.classList.add('doradoFashionCheckout2321V1');
    var meta = document.createElement('meta');
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1";
    document.getElementsByTagName('head')[0].appendChild(meta);
    var e = document.createElement("script");
    e.src = 'https://code.$.com/$-2.2.4.js';
    e.type="text/javascript";
    document.getElementsByTagName("head")[0].appendChild(e);
    var $Intv = setInterval(function(){
      if(typeof $ !== typeof undefined){
        createCartSavingElement();
        $('body').on('DOMSubtreeModified', '.section--shipping-method', function(){
          createCartSavingElement();
        });
        $(document).ajaxComplete(function(){
          createCartSavingElement();
        });
        $(document).on('click', function(){
          clearInterval(intv);
          var intv = setInterval(function(){
            if(!$(".your_saved_price").length && $(".total-line--subtotal .total-line__price").length){
              createCartSavingElement();
              clearInterval(intv);
            }
          });
          setTimeout(function(){
            clearInterval(intv);
          }, 15000);
        });
        clearInterval($Intv);
      }
    });
  }else{
    window.requestAnimationFrame(doradoFashionCheckout2321V1);
  }
};
window.doradoFashionCheckout2321V1(); 
function getPriceFromStringValue(price){
  price = price.toLowerCase();
  price = price.replace("$", "").replace("usd", "").trim();
  return price;
}
function addSavingStripInCheckout(){
  if(!$(".your_saved_price").length){
    var tr = document.createElement("tr");
    tr.setAttribute("class", "your_saved_price");
    tr.innerHTML = '<th class="total-line__name" scope="row"></th><td class="total-line__price total_savePrice" your-savings="0"><span class="order-summary__emphasis savePrice" ></span></td>';
    var node = document.querySelectorAll(".order-summary__section--total-lines .total-line-table__tbody")[0];
    node.insertBefore(tr, node.children[1]);
  }
  var itemTotal = 0;
  if($("span.order-summary-toggle__total-recap.total-recap").attr("cart-original-price") !== null && typeof $("span.order-summary-toggle__total-recap.total-recap").attr("cart-original-price") !== typeof undefined){
    itemTotal = $("span.order-summary-toggle__total-recap.total-recap").attr("cart-original-price");
    itemTotal = getPriceFromStringValue(itemTotal);
  }
  var cartTotal = $(".total-line--subtotal td.total-line__price .order-summary__emphasis").text();
  cartTotal = getPriceFromStringValue(cartTotal);
  var yourSavings = parseFloat(itemTotal)-parseFloat(cartTotal);
  yourSavings = yourSavings.toFixed(2);
  yourSavings = yourSavings.replace(".00", "");
  $(".order-summary-toggle").addClass("itemDetailsUpdated");
  $(".order-summary-toggle > span.wrap").attr("cart-savings", "You save $"+ yourSavings);
  $(".your_saved_price .total_savePrice .savePrice").text("You save $"+ yourSavings);
}
var getQueryString = function (url,field) {
  var href = url ? url : window.location.href;
  var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
  var string = reg.exec(href);
  return string ? string[1] : null;
};
function addCartTotalItemPrice(cartTotalPrice){
  var cartTotal = 0, price=0;
  var elem = $(".order-summary__section__content table.product-table tbody tr");
  elem.each(function(){
    if(typeof $(this).find(".product__price").attr("item-original-price") !== typeof undefined && $(this).find(".product__price").attr("item-original-price") !=""){
      var pr = $(this).find(".product__price").attr("item-original-price");
      pr = getPriceFromStringValue(pr);
      price = parseFloat(price) + parseFloat(pr);
    }    
  });
  cartTotal = parseFloat(cartTotal) + parseFloat(price);
  $("span.order-summary-toggle__total-recap.total-recap").attr('cart-original-price', "$" + cartTotal);
  $(".total-line--subtotal td.total-line__price").attr('cart-original-price', "$" + cartTotal);
}
function createCartSavingElement (){
  var itemsInCart = 0, countText = "";
  $("span.order-summary-toggle__total-recap.total-recap").attr("cart-original-price", 0);
  if($(".order-summary__section__content table.product-table tbody tr").length){
    var elem = $(".order-summary__section__content table.product-table tbody tr");
    elem.each(function(){
      var qty = $(this).find(".product-thumbnail__quantity").text();
      itemsInCart = parseInt(itemsInCart) + parseInt(qty);
    });
  }
  if(itemsInCart > 1){
    countText = " items";
  }
  else if(itemsInCart == 1){
    countText = " item";
  }
  $(".order-summary-toggle").addClass("itemDetailsUpdated");
  $(".order-summary-toggle > span.wrap").attr("item-in-cart", itemsInCart + countText);
  getItemsAvailableInCart();
}
function getItemsAvailableInCart(){
  $.ajax({
    url : "https://www.doradofashion.com/cart",
    method: "GET",
    global: false,
    success: function(res){
      if($(res).find(".cart__row .grid.grid--full.cart__row--table-large").length){
        var elem = $(res).find(".cart__row .grid.grid--full.cart__row--table-large");
        if($(res).find(".cart__row .grid.grid--full.cart__row--table-large").length){
          $(res).find(".cart__row .grid.grid--full.cart__row--table-large").each(function(){
            if($(this).find(".cart__image").length){
              var qty = $(this).find(".cart__product-qty").val();
              var pdpLink = $(this).find('.cart__image').attr("href");
              if(pdpLink.indexOf("https://www.doradofashion.com") === -1){
                pdpLink = "https://www.doradofashion.com" + pdpLink;
              }
              pdpLink = pdpLink + "&qty="+qty;
              getIndividualProductPrices(pdpLink);
            }
          });
        }
      }
    },
    error: function(){
      console.log("unable to load product description", e);
    }
  });
}
function getIndividualProductPrices(pdpUrl) {
  $.ajax({
    url : pdpUrl,
    method: "GET",
    global: false,
    success: function(res){
      var responseUrl = this.url;
      var qty = getQueryString(responseUrl, 'qty');
      var variant = getQueryString(responseUrl, 'variant');  
      var originalPrice = $(res).find(".grid__item .product-single__meta .product__price.product__price--compare .money").text();
      var salePrice = $(res).find(".grid__item .product-single__meta .product__price.on-sale .money").text();
      var orPrice = originalPrice.replace("$", "").replace("USD", "");
      orPrice = parseFloat(orPrice) * parseInt(qty);
      orPrice = orPrice.toFixed(2);
      $(".order-summary__section__content table.product-table tbody tr[data-variant-id='"+variant+"']").find(".product__price").attr("item-original-price", "$" + orPrice);
      addCartTotalItemPrice(orPrice);
      addSavingStripInCheckout();
    },
    error: function(){
      console.log("unable to load product description", e);
    }
  });
}



*/